<template>
  <Ver v-if="isBlocked" :mode="blockMode" />

  <router-view v-else></router-view>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import apiClient from '@/api';
import Ver from "@/views/errors/Ver.vue";

// ТЕКУЩАЯ ВЕРСИЯ ТВОЕГО КЛИЕНТА
const CURRENT_VERSION = '0.0.2';

const isBlocked = ref(false);
const blockMode = ref('outdated'); // 'outdated' или 'maintenance'

/**
 * Сравнение версий (SemVer)
 */
const compareVersions = (vClient, vServer) => {
  const c = vClient.split('.').map(Number);
  const s = vServer.split('.').map(Number);
  for (let i = 0; i < 3; i++) {
    if ((s[i] || 0) > (c[i] || 0)) return true;
    if ((s[i] || 0) < (c[i] || 0)) return false;
  }
  return false;
};

/**
 * Проверка статуса системы
 */
const checkSystemStatus = async () => {
  try {
    const { data } = await apiClient.get('/api/v1/version');
    const result = data?.result || data;

    const serverVersion = result?.version;
    const serverEnabled = result?.enabled ?? true;

    // 1. Если бэкенд выключил приложение (enabled: false)
    if (!serverEnabled) {
      blockMode.value = 'maintenance';
      isBlocked.value = true;
      return;
    }

    // 2. Если включено, но версия старая
    if (serverVersion && compareVersions(CURRENT_VERSION, serverVersion)) {
      blockMode.value = 'outdated';
      isBlocked.value = true;
      return;
    }

    // Если всё в порядке
    isBlocked.value = false;
  } catch (e) {
    // В случае ошибки API (сервер не отвечает) — игнорируем, чтобы не блокировать юзера
    console.warn('Не удалось проверить статус системы');
  }
};

onMounted(() => {
  checkSystemStatus();

  // Опрос каждые 30 секунд
  setInterval(() => {
    checkSystemStatus();
  }, 30 * 1000);
});
</script>